export interface ObjectImage {
  actual?: any;
  guid?: string;
  modifyDate?: Date;
  small?: any;
  tiny?: any;
  id?: string;
}
